import { render, staticRenderFns } from "./Greeter.vue?vue&type=template&id=0297707a&scoped=true&"
import script from "./Greeter.vue?vue&type=script&lang=js&"
export * from "./Greeter.vue?vue&type=script&lang=js&"
import style0 from "./Greeter.vue?vue&type=style&index=0&id=0297707a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297707a",
  null
  
)

export default component.exports